import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';

export const nativeUpdateGuard: CanMatchFn = () => {
  if (Capacitor.isNativePlatform()) {
    return true;
  }

  // A atualização obrigatória pertence apenas ao aplicativo instalado.
  return inject(Router).createUrlTree(['/dashboard']);
};
